module.exports = __webpack_public_path__ + "img/pot2.fef7bb4e.svg";